<template>
  <div class="acmper">
    <div>
      <button
        class="buto"
        @click="$router.back()"
      >返回队伍</button>
    </div>

    <div style="margin-top:20px">
      <van-row>
        <van-col
          span="4"
          class="text-center"
        >队伍</van-col>
        <van-col
          span="3"
          class="text-center"
        >职务</van-col>
        <van-col
          span="5"
          class="text-center"
        >姓名</van-col>
        <van-col
          span="6"
          class="text-center"
        >房间</van-col>

        <van-col
          span="6"
          class="text-center"
        >电话</van-col>
      </van-row>

      <div style="margin-top:5px">
        <div
          v-for="(item2,index2) in List"
          :key="index2"
        >
          <van-row
            type="flex"
            style="margin-top:5px"
          >
            <van-col
              span="4"
              class="text-center line-h20"
            >
              {{item2.team_name}}
            </van-col>
            <van-col
              span="3"
              class="text-center line-h20"
            >
              {{item2.job}}
            </van-col>
            <van-col
              span="5"
              class="text-center line-h20"
            >{{item2.name}}</van-col>
            <van-col
              span="6"
              class="text-center "
            >
              <input
                @focus="$event.target.select()"
                type="text"
                v-model.number="item2.room"
                style="width:85%;text-align: center;"
                :disabled="disable"
                @change="roomChange(item2,$event)"
              >
            </van-col>
            <van-col
              span="6"
              class="text-center line-h20"
              style="color:#ee0a24;"
              @click="onMobile(item2.mobile)"
            >
              {{item2.mobile}}
            </van-col>
          </van-row>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      List: [],
      project_id: '',
      disable: false,
      job: '',
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.getInfo()
  },
  methods: {
    async getInfo() {
      const res = await this.$axios.get('project/staff', {
        params: {
          project_id: this.project_id,
        },
      })

      this.job = res.data.job
      if (this.job != '1') {
        this.disable = true
      } else {
        this.disable = false
      }
      this.List = res.data.data
    },
    roomChange(item, e) {
      let room = e.target.value
      this.$axios
        .post('/project/update-staff', {
          project_id: this.project_id,
          id_number: item.id_number,
          room: room,
        })
        .then((res) => {
          console.log(res)
          this.$toast(res.data.msg)
          this.getInfo()
        })
    },
    onMobile(phoneNumber) {
      console.log(phoneNumber, '手机号')
      if (phoneNumber) {
        window.location.href = 'tel://' + phoneNumber
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.acmper {
  padding: 10px 20px;
  height: 100%;

  .buto {
    background-color: #ee0a24;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
  }
  .text-center {
    text-align: center;
    font-weight: 700;
    padding: 5px 0;
  }
}
.line-h20 {
  line-height: 20px;
}
</style>